module.exports = __webpack_public_path__ + "static/NFTVal-f54af4c1a4a2430575a6c4a42a60a364.jpg";